import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import { DefaultTaskActivityPanel } from "defaultTask/activity/DefaultTaskActivityPanel";
import { DefaultTaskDetailSection } from "defaultTask/DefaultTaskDetailSection";
import TwoColumnLayout from "layout/TwoColumnLayout";
import React from "react";
import { useLoaderData } from "react-router";
import DefaultTaskDetailOptionsPanel from "./DefaultTaskDetailOptionsPanel";

const DefaultTaskDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.DefaultTaskDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <DefaultTaskDetailSection
            userTaskTemplate={viewModel.userTaskTemplate}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <DefaultTaskDetailOptionsPanel
            userTaskTemplate={viewModel.userTaskTemplate}
            listUrl={viewModel.listUrl}
            optionsPanelData={viewModel.optionsPanel}
          />
          <DefaultTaskActivityPanel
            defaultTaskId={viewModel.userTaskTemplate.userTaskTemplateId}
            config={viewModel.activityPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default DefaultTaskDetailApp;